import Grid from '@material-ui/core/Grid';
import Alert from 'components/CncUI/Alert';

const Alerts = () => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <h2 className="header">Alerts</h2>
    </Grid>
    <Grid item xs={6} md={3}>
      <Alert info fullWidth>
        Message goes here
      </Alert>
    </Grid>
    <Grid item xs={6} md={3}>
      <Alert success fullWidth>
        Message goes here
      </Alert>
    </Grid>
    <Grid item xs={6} md={3}>
      <Alert warning fullWidth>
        Message goes here
      </Alert>
    </Grid>
    <Grid item xs={6} md={3}>
      <Alert error fullWidth>
        Message goes here
      </Alert>
    </Grid>
  </Grid>
);

export default Alerts;
